<template>
  <div class="flyingBook">
    <img style="width: 50px" src="../../assets/images/loading.gif" alt="" />
  </div>
</template>

<script>
import { getUiFitment } from '@/utils/accessResources';
import {
  setAccount,
  setToken,
  // eslint-disable-next-line import/extensions
} from '../login/login-handler.js';
// eslint-disable-next-line import/no-cycle
import ApprovalClass from './ApprovalClass';

export default {
  components: {},
  data() {
    return {
      class: new ApprovalClass(),
    };
  },
  computed: {},
  created() {
  },
  mounted() {
    this.init();
  },
  /**
   * 该页面为新审批，目标网站的中转页面
   */
  methods: {
    init() {
      // eslint-disable-next-line camelcase
      const res_data = JSON.parse(this.class.getQueryStringSource().data);
      setToken(res_data.url_res);
      this.class.initenv();
      setAccount(res_data.url_login_res, res_data.url_res);
      getUiFitment().finally(() => {
        this.$router.push({
          path: res_data.path,
          query: {
            ...res_data.query,
          },
        });
      });
    },

  },
};
</script>

<style lang="less" scoped>
.flyingBook {
  width: 400px;
  margin: 0 auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -60%, 0);

  img {
    display: block;

  }

  div {
    // position: absolute;
    text-align: center;
    font-size: 22px;
    margin-top: 16px;
  }
}
</style>
